import { useMemo } from 'react';
import type { CalculatorMarket, CalculatorMatchSelection } from '@nowscore/core';
import type { MatchDto } from '../api';
import { useBodyScrollLock } from '../hooks/useBodyScrollLock';
import { formatKickoff } from '../lib/format';
import { LotteryMarketGrid, LotteryMarketTabs } from './LotteryMarketGrid';

export function DailyOverview({ open, date, league, matches, activeMarket, selections, onMarketChange, onSelectionChange, onClose, onAnalyze }: {
  open: boolean;
  date: string;
  league: string;
  matches: MatchDto[];
  activeMarket: CalculatorMarket;
  selections: Record<string, CalculatorMatchSelection>;
  onMarketChange: (market: CalculatorMarket) => void;
  onSelectionChange: (selection: CalculatorMatchSelection) => void;
  onClose: () => void;
  onAnalyze: (match: MatchDto) => void;
}) {
  useBodyScrollLock(open);
  const visible = useMemo(() => matches.filter((match) => !league || league === 'all' || match.leagueCode === league), [matches, league]);
  if (!open) return null;
  return <section className="daily-overlay" data-no-pull-refresh role="dialog" aria-modal="true" aria-label="今日官方竞彩计算器">
    <header className="analysis-drawer-head"><div><span className="ai-kicker">今日官方竞彩</span><h2>{date} · {visible.length} 场</h2><p>与主界面共用同一份官方 SP 和选择状态</p></div><button className="close-button" onClick={onClose}>关闭</button></header>
    <div className="daily-market-tabs"><LotteryMarketTabs value={activeMarket} onChange={onMarketChange} /></div>
    <div className="daily-body"><div className="daily-list official-daily-list">{visible.map((match) => <article className="daily-match-card" key={match.scheduleId}>
      <div className="daily-match-head"><div><b>{match.lottery?.number ?? match.scheduleId}</b><span>{match.homeTeamName} vs {match.awayTeamName}</span><small>{formatKickoff(match.kickoffTime)} · {match.leagueName ?? match.leagueCode}</small></div><button type="button" className="ghost" onClick={() => onAnalyze(match)}>AI 分析</button></div>
      {match.lottery?.odds?.length ? <LotteryMarketGrid match={match} market={activeMarket} selection={selections[match.scheduleId]} onChange={onSelectionChange} compact /> : <div className="analysis-empty">官方竞彩赔率缺失</div>}
    </article>)}</div></div>
  </section>;
}